export const categories = [
  { slug: 'all', name: '全部作品', icon: 'ri-film-line', description: '大桥未久全系列作品合集' },
  { slug: 'latest', name: '最新作品', icon: 'ri-sparkling-line', description: '大桥未久最新发布作品' },
  { slug: 'masterpiece', name: '代表作', icon: 'ri-star-line', description: '大桥未久经典代表作' },
  { slug: 'photo-book', name: '写真集', icon: 'ri-camera-line', description: '大桥未久精美写真集' },
  { slug: 'fan-news', name: '粉丝资讯', icon: 'ri-heart-line', description: '粉丝必看最新动态' },
];

export const categoryMap: Record<string, string> = {
  'all': '全部作品',
  'latest': '最新作品',
  'masterpiece': '代表作',
  'photo-book': '写真集',
  'fan-news': '粉丝资讯',
};